import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { LoginDuck } from 'features/login/LoginDuck';
import './assets/scss/main.scss';

import App from './App';
import languageService from "./features/language/languageService";
import dispatchService from "./utils/DispatchService";
import { setAxiosDispatcher } from "./utils/axios";
import configureAppStore from "./configStore";
import 'dayjs/locale/sv';
import 'dayjs/locale/da';
import navigationBlocker from "./utils/NavigationBlocker";

import * as Sentry from "@sentry/react";
import configDB from './configDB';
import Plausible from 'plausible-tracker';
import { LN_ENV } from './AppConstants';

import { StrictMode } from 'react';

if (LN_ENV === "production") {

    Plausible({
        domain: 'portal.laranara.se'
    }).enableAutoPageviews();


    Sentry.init({

        dsn: "https://5b9e34bde391df8c86b07d0c9d9e3ca6@o4507208376320000.ingest.de.sentry.io/4507208378548304",
        integrations: [
            Sentry.browserTracingIntegration()
        ],

        tracesSampleRate: 0.01,
        ignoreErrors: [
            "ResizeObserver loop limit exceeded", /^No error$/,
            /__show__deepen/,
            /_avast_submit/,
            /Access is denied/,
            /anonymous function: captureException/,
            /Blocked a frame with origin/,
            /can't redefine non-configurable property "userAgent"/,
            /change_ua/,
            /console is not defined/,
            /cordova/,
            /DataCloneError/,
            /Error: AccessDeny/,
            /event is not defined/,
            /feedConf/,
            /ibFindAllVideos/,
            /myGloFrameList/,
            /SecurityError/,
            /MyIPhoneApp/,
            /snapchat.com/,
            /vid_mate_check is not defined/,
            /win\.document\.body/,
            /window\._sharedData\.entry_data/,
            /window\.regainData/,
            /ztePageScrollModule/
        ],

    });
}


const store = configureAppStore(false);

export const lnDataBase = configDB();

// TODO: These cause errors when building
// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store



navigationBlocker.init(store);

let redirPath = window.location.pathname;
if (store.getState().login.loggedIn || redirPath === "/") {

    redirPath = null;
}
store.dispatch(LoginDuck.setRedirectUrl(redirPath));

// the lookup of text in the i18n dictionary
languageService.registerStore(store);

// Make axios able to dispatch actions into Redux
setAxiosDispatcher(store.dispatch);

// set up dispatch service with it's store.
dispatchService.SetStore(store);

const root = createRoot(document.getElementById('root'));
root.render(<StrictMode>
    <Provider store={store}>
        <App /></Provider>
</StrictMode>);


